<script>
  import Avatar from '@components/Avatar.svelte';
  import Text from '@components/Text.svelte';
  import AccountVerifiedIcon from '@app-components/AccountVerifiedIcon.svelte';
  import CommentMenu from './CommentMenu.svelte';
  import Track from '@utils/track';
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  import jQuery from 'jquery';
  import CommentActions from './CommentActions.svelte';

  export let comment;
  export let currentUser;
  export let deleteComment;
  export let parentComment;
  export let expanded = false;
  export let group;
  export let invertedColors = false;
  export let mobile;
  export let recObject;
  export let reFetchRecObject;
  export let rootComment;
  export let toggleReplies = null;
  export let viewStyle;
  export let customContext;

  let shavedOnFirstLoad;
  let linesForComment = 999;

  let currentUserComment = (comment) => {
    return comment && comment.user && currentUser && comment.user.id == currentUser.id;
  };

  let goToAuthorOrOpenComment = function (comment) {
    return function () {
      if (mobile && shavedOnFirstLoad) {
        let spanEl = jQuery(`.comment-box-${comment.id}`).find('.text-widget');

        if (spanEl) {
          spanEl.click();
          spanEl.focus();
        }
      } else {
        location.href = comment.user.profile_path;
      }
    };
  };
</script>

<style style="text/scss" lang="scss">
  * {
    --editable-focused-border-color: transparent;
  }

  .comment-box {
    display: flex;
    margin-top: 15px;
    align-items: flex-start;

    .comment-avatar {
      width: 27px;
      height: 27px;
      flex-shrink: 0;
      z-index: 2;
    }

    .comment-body {
      margin-left: 15px;
      background: #fff;
      color: #5e518e;
      border-radius: 15px;
      line-height: 24px;
      padding: 10px;
      padding-left: 15px;
      padding-right: 15px;
      width: 100%;
      display: block;
      flex-direction: column;

      .comment-author {
        color: #000;
        font-weight: 500;
        flex-shrink: 0;
        margin-top: 2px;
      }
    }
  }

  .mobile {
    .comment-body {
      display: block !important;
      line-height: 18px !important;

      .comment-author {
        margin-right: 0px !important;
        margin-bottom: 5px !important;
        margin-top: 0px !important;
      }
    }
  }

  // #TODO check this
  .inverted {
    .comment-body {
      background: #f8f6ff !important;
    }
  }

  .comment-body {
    background: #f5f3fc !important;
  }

  .comment-top-row {
    position: relative;
    display: inline-flex;
    flex-direction: row;
    gap: 6px;
    justify-content: space-between;
    width: 100%;
  }
</style>

{#if comment.user}
  <div
    id="comment-box-{comment.id}"
    class="comment-box comment-box-{comment.id} {rootComment ? '' : 'reply'} {mobile ? 'mobile' : ''} {invertedColors
      ? 'inverted'
      : ''}">
    <div class="comment-avatar" style="margin-top: 8px;">
      {#if comment.user}
        <Avatar
          href={comment.user.profile_path}
          src={comment.user.avatar_url}
          width={27}
          user={comment.user}
          mobile={mobile} />
      {:else}
        <Avatar src={'/images/user-placeholder.png'} width={27} />
      {/if}
    </div>

    <div class="comment-body">
      <div class="comment-top-row">
        {#if comment.user}
          <AccountVerifiedIcon
            dimension={12}
            verified={comment.user.verified}
            extraStyleIcon={mobile ? 'margin-bottom: 5px;' : 'margin-top: 2px;'}
            clickable={true}
            on:areaClicked={() => goToAuthorOrOpenComment(comment)}>
            <svelte:fragment slot="account-name">
              <a
                on:click|preventDefault|stopPropagation={goToAuthorOrOpenComment(comment)}
                class="comment-author"
                href={comment.user.profile_path}>
                {comment.user.name}
              </a>
            </svelte:fragment>
          </AccountVerifiedIcon>
        {/if}
        <CommentMenu
          isOwner={group.permissions.edit}
          currentUserComment={currentUserComment(comment)}
          mobile={mobile}
          detailsViewOption={true}
          comment={comment}
          context={customContext || (recObject ? 'rec' : 'list')}
          handleDelete={(spamChecked) => deleteComment(comment, spamChecked)} />
      </div>

      <Text
        editor={false}
        linkClicked={(url) => {
          Track.commentLinkClicked({
            user: currentUser,
            group,
            comment,
            url,
          });
        }}
        on:click={() => {
          dispatch('click');
        }}
        style="font-weight: normal; width: 100%; padding: 0px; margin:
                0px; padding-left: 5px; padding-right: 5px; margin-left: -5px;
                margin-right: -5px; margin-bottom: -5px;"
        editable={false}
        expand={viewStyle === 'detail-view'}
        text={comment.body}
        documentId={`comment-${comment.id}`}
        lines={linesForComment}
        bind:shavedOnFirstLoad={shavedOnFirstLoad} />
    </div>
  </div>
  <CommentActions
    mobile={mobile}
    recObject={recObject}
    group={group}
    comment={comment}
    parentComment={parentComment}
    rootComment={rootComment}
    expanded={expanded}
    toggleReplies={(c) => toggleReplies(c)}
    reFetchRecObject={() => reFetchRecObject()}
    customContext={customContext} />
{/if}
